export default __webpack_public_path__ + "static/media/brain.76e3a2d3.png";